import React from 'react';
import PropTypes from 'prop-types';
import {StyledSpan, StyledSVG} from './star_icon.styled';

const SIZE = {
	STANDARD: 'standard',
	LARGE: 'large',
};

export const StarIcon = ({size, active, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.STANDARD:
				return '14';
			case SIZE.LARGE:
				return '32';
			default:
				return '14';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.STANDARD:
				return '14';
			case SIZE.LARGE:
				return '32';
			default:
				return '14';
		}
	};

	const handleStarClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick();
		}
	};
	return (
		<StyledSpan onClick={handleStarClick} width={getWidth(size)} height={getHeight(size)} data-cy={'star-icon'}>
			<StyledSVG
				xmlns="http://www.w3.org/2000/svg"
				width={getWidth(size)}
				height={getHeight(size)}
				viewBox={'0 0 14 14'}
				active={active}
			>
				{active ? (
					<path
						fillRule="nonzero"
						d="M3.46 13.798a1.391 1.391 0 0 1-1.9-.45 1.352 1.352 0 0 1-.141-1.12l1.183-3.753L.445 6.506a1.354 1.354 0 0 1-.079-1.93c.262-.28.63-.439 1.016-.439h2.926L5.73.832A1.388 1.388 0 0 1 8.272.83l1.424 3.306h2.922c.763 0 1.382.612 1.382 1.366 0 .38-.161.745-.445 1.003l-2.157 1.969 1.183 3.753c.227.72-.18 1.485-.908 1.71-.38.117-.793.066-1.133-.14L7 11.652l-3.54 2.146z"
					/>
				) : (
					<path
						fillRule="nonzero"
						d="M3.46 13.798a1.391 1.391 0 0 1-1.9-.45 1.352 1.352 0 0 1-.141-1.12l1.183-3.753L.445 6.506a1.354 1.354 0 0 1-.079-1.93c.262-.28.63-.439 1.016-.439h2.926L5.73.832A1.388 1.388 0 0 1 8.272.83l1.424 3.306h2.922c.763 0 1.382.612 1.382 1.366 0 .38-.161.745-.445 1.003l-2.157 1.969 1.183 3.753c.227.72-.18 1.485-.908 1.71-.38.117-.793.066-1.133-.14L7 11.652l-3.54 2.146zm7.636-.895c.078.047.173.06.261.032a.314.314 0 0 0 .21-.395l-1.384-4.387 2.652-2.419a.313.313 0 0 0-.217-.546H8.994l-1.7-3.946a.32.32 0 0 0-.587 0L5.011 5.189H1.382a.32.32 0 0 0-.235.101.313.313 0 0 0 .018.445l2.652 2.42-1.384 4.386a.312.312 0 0 0 .033.26.321.321 0 0 0 .438.103L7 10.42l4.096 2.483z"
					/>
				)}
			</StyledSVG>
		</StyledSpan>
	);
};

StarIcon.SIZE = SIZE;
StarIcon.propTypes = {
	onClick: PropTypes.func,
	active: PropTypes.bool,
	size: PropTypes.oneOf([SIZE.STANDARD]),
};
